import { render } from "./FavoritesForm.vue?vue&type=template&id=2ddb9ffc"
import script from "./FavoritesForm.vue?vue&type=script&lang=js"
export * from "./FavoritesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__